import { FC, memo } from "react";
import { ProductParamType } from "@/types";
import { cssName, StyledTable, StyledTableContainer, TableCell, TableRow, TableTitle } from "./StyledDetail";
export type PropertiesPropsType = {
  params: ProductParamType[];
};
export const Properties: FC<PropertiesPropsType> = memo(({
  params
}) => {
  if (!params.length) {
    return null;
  }
  return <StyledTableContainer>
      <TableTitle>Характеристики</TableTitle>
      <StyledTable>
        {params.map(({
        name = "",
        type = "",
        uuid = ""
      }) => <TableRow key={`${uuid}`} data-id={uuid}>
            <TableCell className={cssName}>{type}</TableCell>
            <TableCell>{name}</TableCell>
          </TableRow>)}
      </StyledTable>
    </StyledTableContainer>;
});
Properties.displayName = "Properties";